import { render, staticRenderFns } from "./dgov2Popup.vue?vue&type=template&id=9b6a16c2&scoped=true&"
import script from "./dgov2Popup.vue?vue&type=script&lang=js&"
export * from "./dgov2Popup.vue?vue&type=script&lang=js&"
import style0 from "./scss/dgov2Popup.scss?vue&type=style&index=0&id=9b6a16c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6a16c2",
  null
  
)

export default component.exports